
export const GET_MY_EARNINGS_REQUEST = "GET_MY_EARNINGS_REQUEST";
export const GET_MY_EARNINGS_RECEIVE = "GET_MY_EARNINGS_RECEIVE";
export const GET_MY_EARNINGS_FAILURE = "GET_MY_EARNINGS_FAILURE";
export const RESET_GET_MY_EARNINGS = "RESET_GET_MY_EARNINGS";